var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.85085 1.01172H13.1529C13.6219 1.01172 14.0019 1.39172 14.0019 1.86072V8.63872C14.0019 9.10872 13.6219 9.48872 13.1529 9.48872H8.00085M3.64985 4.51272C4.11411 4.51272 4.55936 4.32829 4.88764 4.00001C5.21593 3.67173 5.40035 3.22648 5.40035 2.76222C5.40035 2.29796 5.21593 1.85271 4.88764 1.52443C4.55936 1.19615 4.11411 1.01172 3.64985 1.01172C3.18559 1.01172 2.74035 1.19615 2.41206 1.52443C2.08378 1.85271 1.89935 2.29796 1.89935 2.76222C1.89935 3.22648 2.08378 3.67173 2.41206 4.00001C2.74035 4.32829 3.18559 4.51272 3.64985 4.51272Z",
    stroke: "#CB8B65",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50085 6.03872C9.50085 5.47172 9.04085 5.01172 8.47385 5.01172H3.64985C2.9473 5.01172 2.27351 5.29081 1.77673 5.78759C1.27994 6.28438 1.00085 6.95816 1.00085 7.66072V10.0117H2.13585L2.51485 14.0117H4.78485L5.65685 7.06672H8.47385C9.04085 7.06672 9.50085 6.60672 9.50085 6.03872Z",
    stroke: "#CB8B65",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_1154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.500854 0.511719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass);
export default __webpack_public_path__ + "static/media/class.25374c25a0c6b95a798cdce65e818c0d.svg";
export { ForwardRef as ReactComponent };